import React, { useState } from "react";

const faqs = [
  {
    q: "What is the cost of appliance repair?",
    a: "The cost depends on the issue and spare parts required. We offer transparent pricing with no hidden charges.",
  },
  {
    q: "Do you provide same-day service?",
    a: "Yes, we provide same-day doorstep service in most areas for quick and hassle-free repairs.",
  },
  {
    q: "Do you service Whirlpool appliances?",
    a: "Yes, we service Whirlpool washing machines, refrigerators, microwaves, and other home appliances across Bangalore.",
  },
  {
    q: "How do I book a repair service?",
    a: "You can book a repair by calling our helpline or using the booking popup on the website.",
  },
];

const FAQ = ({ brand = "default" }) => {
  const [active, setActive] = useState(null);
  const brandClass = `${String(brand).trim().toLowerCase() || "default"}-faq`;

  return (
    <section className={`faq-section ${brandClass}`}>
      <div className="faq-container">
        <h2 className="faq-title">
          Frequently Asked <span>Questions</span>
        </h2>

        <div className="faq-list">
          {faqs.map((item, index) => (
            <div
              key={item.q}
              className={`faq-item ${active === index ? "active" : ""}`}
              onClick={() => setActive(active === index ? null : index)}
            >
              <div className="faq-question">
                <h3>{item.q}</h3>
                <span>{active === index ? "-" : "+"}</span>
              </div>

              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
